module.exports = __webpack_public_path__ + "img/canada-map-en.63a95763.jpg";